export default __webpack_public_path__ + "static/media/avatar_red.a359706f.svg";